import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import DataTable from 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload, faEye } from '@fortawesome/free-solid-svg-icons'

export const Cprogram = ({setProgUrl}) => {
    const [progList, setProgList] = useState([]);
    const [err, setErr] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const tableRef = useRef(null);

    const getApiData = async() =>{
        try{
            const res = await axios.get("/api/repository.php?lang=cprograms")
            setProgList(res.data);
            setLoading(false);
            
        }catch(e){
            setErr(true);
            setLoading(false);
        }
    }

    useEffect(()=>{
        getApiData();
    },[])

    useEffect(()=>{
        if(progList.length>0){
            new DataTable(tableRef.current,{
                responsive: true,
                destroy: true,
                columnDefs: [
                    {
                        searchable: false,
                        orderable: false,
                        targets: [3,4]
                    }
                ],
            });
        }
    },[progList])

  return (
    <div className='page-wrap'>
        <h3>C++ Programs</h3>
        <hr/>
        {err && <div className="m-4 alert alert-danger" role="alert">
                <span className='fs-5'>Network Error.</span>
            </div>
        }
        {isLoading && <div className='shimmer home-shimmer'>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                            <div className='shine'></div>
                        </div>
        }
        <div className='table-wrap'>
            <table className='table table-bordered' ref={tableRef}>
                {!isLoading && !err &&
                <thead>
                    <tr>
                        <th>NAME</th>
                        <th>SIZE</th>
                        <th>DATE</th>
                        <th className='text-center'>VIEW</th>
                        <th className='text-center'>DOWNLOAD</th>
                    </tr>
                </thead>
                }
                <tbody>
                    {progList.map((item, index) => {
                        const {name, size, date, link, download} = item;
                        return  <tr key={index}>
                                    <td>{name}</td>
                                    <td>{size}</td>
                                    <td>{date}</td>
                                    <td onClick={e=> setProgUrl(name, link, download)}><FontAwesomeIcon icon={faEye} /></td>
                                    <td><a href={download} download={name} title='Download' target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDownload} /></a></td>
                                </tr>
                    })}
                    
                </tbody>
            </table>
        </div>
    </div>
  )
}
